<script lang="ts">
  import { isLoggedInStore } from "../../stores";
  import { type TTheme } from "../../utils/types";
  import MenuItem from "./MenuItem.svelte";
  import ChevronUpIcon from "../images/chevron-up.svg";

  export let options: {
    onClick: () => void;
    title: string;
    passIcon: string;
    chevronStyles: string;
    isMinimized: boolean;
    theme: TTheme;
    navbarOverrideImage?: string;
  };

  let { onClick, title, passIcon, theme } = options;

  $: chevronStyles = options.chevronStyles;
  $: isMinimized = options.isMinimized;
  $: navbarOverrideImage = options.navbarOverrideImage;
</script>

{#if navbarOverrideImage}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="crtw-w-56 crtw-h-11 crtw-overflow-hidden crtw-rounded crtw-flex crtw-items-center crtw-justify-center crtw-cursor-pointer"
    on:click={onClick}
    role="button"
    tabindex={0}
  >
    <img
      class="crtw-block crtw-h-full crtw-w-full crtw-object-cover"
      src={navbarOverrideImage}
      alt=""
    />
  </div>
{:else}
  <MenuItem
    options={{
      title,
      onClick,
      isDisabled: false,
      isMinimized,
      theme,
      isMain: true,
    }}
  >
    <div
      class={`crtw-flex crtw-justify-center crtw-items-center crtw-rounded-md`}
      slot="icon"
    >
      <img class="crtw-block crtw-max-w-[30px]" src={passIcon} alt="" />
    </div>
    {#if $isLoggedInStore}
      <img src={ChevronUpIcon} alt="" style={chevronStyles} />
    {/if}
  </MenuItem>
{/if}
